import React from 'react';
import Dashboard from './Dashboard';
import Footer from '../../Layout/Footer';
import { useQuery } from 'react-query';
import { getFolderI } from '../../api/services';
import { LinearProgress, Typography } from '@mui/material';

const DashboardPage: React.FC = () => {

  const { data: Tabsdata, isLoading, isError } = useQuery('alltabs', getFolderI);


  if (isLoading) {
    return <LinearProgress />;
  }

  if (isError) {
    return <Typography>Error loading folders. Please try again later.</Typography>;
  }


  return (
    <>
      <Dashboard folders={Tabsdata?.data} />
    </>
  );
};

export default DashboardPage;